type CountdownProps = {
  seconds: number;
};

async function wait(milliseconds: number) {
  return await new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
}

export class Countdown {
  private seconds: number;

  constructor({ seconds }: CountdownProps) {
    this.seconds = seconds;
  }

  async start(onChange?: (secondsLeft: number) => void, onCompleted?: () => void) {
    let secondsLeft = this.seconds;
    onChange && onChange(secondsLeft);
    while (secondsLeft > 0) {
      await wait(1000);
      secondsLeft--;
      onChange && onChange(secondsLeft);
    }
    onCompleted && onCompleted();
  }
}
